
import React, { useEffect, useState } from "react";
import axios from "axios";
import hostlink from "../Hostlink/hostlink";
import { toast } from "react-toastify";

const EmployeeSalary = () => {

    const user = JSON.parse(
        localStorage.getItem("MYPCKARTUSER") || "{}"
    );

    const shopid = localStorage.getItem('MYPCKARTUSER') ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id : '0';

    const currentDate = new Date();

    const [month, setMonth] = useState(
        currentDate.getMonth() + 1
    );

    const [year, setYear] = useState(
        currentDate.getFullYear()
    );

    const [employees, setEmployees] = useState([]);
    const [salaryData, setSalaryData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
              if (shopid != 0) {
                  loadEmployees();
              }
      
          }, [shopid]);

    useEffect(() => {

        if (employees.length > 0) {
            loadSalary();
        }

    }, [month, year, employees]);

    const loadEmployees = async () => {

        try {

            const response = await axios.get(
                `${hostlink}/list/${shopid}`
            );

            setEmployees(response.data || []);

        } catch (error) {

            console.error(error);
            toast.error("Unable to load employees");
        }
    };

    const getDaysInMonth = () => {

        return new Date(
            year,
            month,
            0
        ).getDate();
    };

    const getDateRange = () => {

        const from =
            `${year}-${String(month).padStart(2, "0")}-01`;

        const to =
            `${year}-${String(month).padStart(2, "0")}-${getDaysInMonth()}`;

        return { from, to };
    };

    const loadSalary = async () => {

    try {

        setLoading(true);

        const [salaryResponse, advanceResponse] =
            await Promise.all([

                axios.get(
                    `${hostlink}/employee-salary/month`,
                    {
                        params: {
                            shopid,
                            month,
                            year
                        }
                    }
                ),

                axios.get(
                    `${hostlink}/employee-attendance/advance/month`,
                    {
                        params: {
                            shopid,
                            month,
                            year
                        }
                    }
                )
            ]);

        const existing = salaryResponse.data || [];
        const advances = advanceResponse.data || [];

        const data = employees.map(employee => {

            const saved = existing.find(
                x =>
                    Number(x.employeeid) ===
                    Number(employee.id)
            );

            // Calculate monthly advance/recovery
            const employeeAdvances = advances.filter(
                x =>
                    Number(x.employeeid) ===
                    Number(employee.id)
            );

            const totalAdvance = employeeAdvances
                .filter(
                    x =>
                        String(x.type || "").toUpperCase() ===
                        "ADVANCE"
                )
                .reduce(
                    (sum, x) =>
                        sum + Number(x.amount || 0),
                    0
                );

            const totalRecovery = employeeAdvances
                .filter(
                    x =>
                        String(x.type || "").toUpperCase() ===
                        "RECOVERY"
                )
                .reduce(
                    (sum, x) =>
                        sum + Number(x.amount || 0),
                    0
                );

            const advanceRecovery =
                totalAdvance - totalRecovery;

            if (saved) {

                return {
                    ...saved,

                    employeeid: employee.id,

                    employeeName:
                        saved.employeeName ||
                        employee.accname,

                    basicSalary:
                        Number(
                            saved.basicSalary ??
                            employee.salary ??
                            0
                        ),

                    advanceRecovery:
                        advanceRecovery > 0
                            ? advanceRecovery
                            : 0
                };

            }

            return {

                employeeid: employee.id,

                employeeName:
                    employee.accname,

                basicSalary:
                    Number(
                        employee.salary ??
                        employee.basicSalary ??
                        0
                    ),

                totalDays: getDaysInMonth(),

                presentDays: 0,
                halfDays: 0,
                absentDays: 0,
                leaveDays: 0,
                holidayDays: 0,
                payableDays: 0,

                earnedSalary: 0,

                overtime: 0,
                bonus: 0,
                deduction: 0,

                advanceRecovery:
                    advanceRecovery > 0
                        ? advanceRecovery
                        : 0,

                netSalary: 0,
                paidAmount: 0,
                balanceAmount: 0,

                status: "OPEN"
            };
        });

        setSalaryData(data);

    } catch (error) {

        console.error(error);

        toast.error(
            "Unable to load salary"
        );

    } finally {

        setLoading(false);
    }
};
    const calculateSalary = async employee => {

    try {

        const response = await axios.get(
            `${hostlink}/employee-attendance/month`,
            {
                params: {
                    shopid,
                    month,
                    year
                }
            }
        );

        const attendance = (response.data || []).filter(
            x => Number(x.employeeid) === Number(employee.employeeid)
        );
       

        const presentDays = attendance.filter(
            x => String(x.status || "").toUpperCase() === "PRESENT"
        ).length;

        const halfDays = attendance.filter(
            x => String(x.status || "").toUpperCase() === "HALF_DAY"
        ).length;

        const absentDays = attendance.filter(
            x => String(x.status || "").toUpperCase() === "ABSENT"
        ).length;

        const leaveDays = attendance.filter(
            x => String(x.status || "").toUpperCase() === "LEAVE"
        ).length;

        // Sunday / Holiday entered manually
       const holidayDays = attendance.filter(x => {
    const status = String(x.status || "").trim().toUpperCase();

    return (
        status === "HOLIDAY" ||
        status === "H" ||
        status === "SUNDAY"
    );
}).length;

        const basicSalary =
            Number(employee.basicSalary || 0);

        const totalDays = getDaysInMonth();

        const perDay =
            totalDays > 0
                ? basicSalary / totalDays
                : 0;

        // Holiday is FULL PAY
        const earnedSalary =
            (presentDays * perDay) +
            (halfDays * perDay * 0.5) +
            (leaveDays * perDay) +
            (holidayDays * perDay);

        const netSalary =
            earnedSalary +
            Number(employee.overtime || 0) +
            Number(employee.bonus || 0) -
            Number(employee.deduction || 0) -
            Number(employee.advanceRecovery || 0);

            const payableDays =
    presentDays +
    (halfDays * 0.5) +
    leaveDays +
    holidayDays;
        return {
            ...employee,

            totalDays,
            payableDays,

            presentDays,
            halfDays,
            absentDays,
            leaveDays,
            holidayDays,

            earnedSalary,
            netSalary,

            balanceAmount:
                netSalary -
                Number(employee.paidAmount || 0)
        };

    } catch (error) {

        console.error(error);

        toast.error(
            `Unable to calculate ${employee.employeeName || "salary"}`
        );

        return employee;
    }
};

    const calculateAll = async () => {

        setLoading(true);

        const result = [];

        for (const employee of salaryData) {

            const calculated =
                await calculateSalary(employee);

            result.push(calculated);
        }

        setSalaryData(result);

        setLoading(false);

        toast.success("Salary calculated");
    };

    const updateField = (index, field, value) => {

        setSalaryData(prev => {

            const copy = [...prev];

            copy[index] = {
                ...copy[index],
                [field]: Number(value) || 0
            };

            const item = copy[index];

            item.netSalary =
                Number(item.earnedSalary || 0) +
                Number(item.overtime || 0) +
                Number(item.bonus || 0) -
                Number(item.deduction || 0) -
                Number(item.advanceRecovery || 0);

            item.balanceAmount =
                item.netSalary -
                Number(item.paidAmount || 0);

            return copy;
        });
    };

    const saveSalary = async (item) => {
    try {

        const data = {
            employeeid: Number(item.employeeid),
            employeeName: item.employeeName || "",

            shopid: Number(shopid),

            salarymonth: Number(month),
            salaryyear: Number(year),

            salaryDate: new Date()
                .toISOString()
                .split("T")[0],

            basicSalary: Number(item.basicSalary || 0),

            totalDays: Number(item.totalDays || 0),
            presentDays: Number(item.presentDays || 0),
            halfDays: Number(item.halfDays || 0),
            absentDays: Number(item.absentDays || 0),
            leaveDays: Number(item.leaveDays || 0),
            holidayDays: Number(item.holidayDays || 0),
            payableDays: Number(item.payableDays || 0),

            earnedSalary: Number(item.earnedSalary || 0),

            overtime: Number(item.overtime || 0),
            bonus: Number(item.bonus || 0),
            deduction: Number(item.deduction || 0),

            advanceRecovery: Number(item.advanceRecovery || 0),

            netSalary: Number(item.netSalary || 0),
            paidAmount: Number(item.paidAmount || 0),
            balanceAmount: Number(item.balanceAmount || 0),

            status:
                Number(item.paidAmount || 0) >=
                Number(item.netSalary || 0)
                    ? "PAID"
                    : Number(item.paidAmount || 0) > 0
                        ? "PARTIAL"
                        : "OPEN"
        };

        console.log("Saving salary:", data);

        const response = await axios.post(
            `${hostlink}/employee-salary/save`,
            data
        );

        console.log("Salary saved:", response.data);

        toast.success(
            `${item.employeeName || "Salary"} saved successfully`
        );

        return true;

    } catch (error) {

        console.error(
            "Salary save error:",
            error.response?.data || error.message
        );

        toast.error(
            error.response?.data?.message ||
            `Unable to save ${item.employeeName || "salary"}`
        );

        throw error;
    }
};


const saveAll = async () => {

    setLoading(true);

    try {

        for (const item of salaryData) {
            await saveSalary(item);
        }

        toast.success("All salaries saved successfully");

    } catch (error) {

        console.error("Save all error:", error);

        toast.error(
            "Some salaries could not be saved"
        );

    } finally {

        setLoading(false);
    }
};

    const totalBasic = salaryData.reduce(
        (sum, x) => sum + Number(x.basicSalary || 0),
        0
    );

    const totalEarned = salaryData.reduce(
        (sum, x) => sum + Number(x.earnedSalary || 0),
        0
    );

    const totalNet = salaryData.reduce(
        (sum, x) => sum + Number(x.netSalary || 0),
        0
    );

    const totalBalance = salaryData.reduce(
        (sum, x) => sum + Number(x.balanceAmount || 0),
        0
    );

    const monthName = new Date(
        year,
        month - 1,
        1
    ).toLocaleString("en-IN", {
        month: "long"
    });

    return (
        <div className="container-fluid py-3 salary-page">

            <div className="salary-header mb-3">

                <div className="header-title">

                    <div className="header-icon">
                        <i className="fa-solid fa-calculator"></i>
                    </div>

                    <div>
                        <h4>Salary Processing</h4>
                        <small>
                            Process employee salary for {monthName} {year}
                        </small>
                    </div>

                </div>


                <div className="month-selector">

                    <select
                        className="form-select"
                        value={month}
                        onChange={e =>
                            setMonth(Number(e.target.value))
                        }
                    >
                        {[
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ].map((name, index) => (
                            <option
                                key={name}
                                value={index + 1}
                            >
                                {name}
                            </option>
                        ))}
                    </select>

                    <select
                        className="form-select"
                        value={year}
                        onChange={e =>
                            setYear(Number(e.target.value))
                        }
                    >
                        {[2024, 2025, 2026, 2027, 2028].map(y => (
                            <option key={y} value={y}>
                                {y}
                            </option>
                        ))}
                    </select>

                </div>

            </div>


            <div className="row g-3 mb-3">

                <div className="col-xl-3 col-md-6">
                    <div className="summary-card">
                        <small>Basic Salary</small>
                        <h4>
                            ₹ {totalBasic.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6">
                    <div className="summary-card">
                        <small>Earned Salary</small>
                        <h4>
                            ₹ {totalEarned.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6">
                    <div className="summary-card">
                        <small>Net Salary</small>
                        <h4>
                            ₹ {totalNet.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

                <div className="col-xl-3 col-md-6">
                    <div className="summary-card balance">
                        <small>Payable Balance</small>
                        <h4>
                            ₹ {totalBalance.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

            </div>


            <div className="salary-container">

                <div className="salary-toolbar">

                    <div>
                        <h5>
                            <i className="fa-solid fa-users me-2"></i>
                            Employee Salary
                        </h5>

                        <small>
                            {salaryData.length} employees
                        </small>
                    </div>

                    <div className="toolbar-actions">

                        <button
                            className="btn btn-outline-dark btn-sm"
                            onClick={calculateAll}
                            disabled={loading}
                        >
                            <i className="fa-solid fa-arrows-rotate me-1"></i>
                            Calculate
                        </button>

                        <button
                            className="btn btn-dark btn-sm"
                            onClick={saveAll}
                            disabled={loading}
                        >
                            <i className="fa-solid fa-floppy-disk me-1"></i>
                            Save All
                        </button>

                    </div>

                </div>


                <div className="table-responsive">

                    <table className="table salary-table mb-0">

                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Basic</th>
                                <th>Present</th>
                                <th>Half</th>
                                <th>Absent</th>
                                <th>Holiday</th>
                                <th>Payable Days</th>
                                <th>Earned</th>
                                <th>Bonus</th>
                                <th>Deduction</th>
                                <th>Advance</th>
                                <th>Net Salary</th>
                                <th>Balance</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>

                            {loading ? (

                                <tr>
                                    <td
                                        colSpan="12"
                                        className="text-center py-5"
                                    >
                                        <div className="spinner-border"></div>
                                    </td>
                                </tr>

                            ) : salaryData.length === 0 ? (

                                <tr>
                                    <td
                                        colSpan="12"
                                        className="text-center py-5 text-muted"
                                    >
                                        No employees found
                                    </td>
                                </tr>

                            ) : (

                                salaryData.map((item, index) => (

                                    <tr key={item.employeeid}>

                                        <td>

                                            <div className="employee-cell">

                                                <div className="avatar">
                                                    {(
                                                        item.employeeName ||
                                                        employees.find(
                                                            e =>
                                                                e.id ===
                                                                item.employeeid
                                                        )?.accname ||
                                                        "E"
                                                    )
                                                        .charAt(0)
                                                        .toUpperCase()}
                                                </div>

                                                <div>
                                                    <strong>
                                                        {
                                                            item.employeeName ||
                                                            employees.find(
                                                                e =>
                                                                    e.id ===
                                                                    item.employeeid
                                                            )?.accname
                                                        }
                                                    </strong>

                                                    <small>
                                                        #{item.employeeid}
                                                    </small>
                                                </div>

                                            </div>

                                        </td>

                                        <td>
                                            ₹{" "}
                                            {Number(
                                                item.basicSalary || 0
                                            ).toLocaleString("en-IN")}
                                        </td>

                                        <td>
                                            <span className="days present">
                                                {item.presentDays || 0}
                                            </span>
                                        </td>

                                        <td>
                                            {item.halfDays || 0}
                                        </td>

                                        <td>
                                            <span className="days absent">
                                                {item.absentDays || 0}
                                            </span>
                                        </td>
                                        <td>
    <span className="days holiday">
        {item.holidayDays || 0}
    </span>
</td>
<td>
    <span className="days payable">
        {Number(item.payableDays || 0).toFixed(1)}
    </span>
</td>

                                        <td className="fw-bold">
                                            ₹{" "}
                                            {Number(
                                                item.earnedSalary || 0
                                            ).toLocaleString("en-IN")}
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                className="salary-input"
                                                value={item.bonus || ""}
                                                onChange={e =>
                                                    updateField(
                                                        index,
                                                        "bonus",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                className="salary-input"
                                                value={
                                                    item.deduction || ""
                                                }
                                                onChange={e =>
                                                    updateField(
                                                        index,
                                                        "deduction",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                className="salary-input"
                                                value={
                                                    item.advanceRecovery || ""
                                                }
                                                onChange={e =>
                                                    updateField(
                                                        index,
                                                        "advanceRecovery",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </td>

                                        <td>
                                            <strong className="net-value">
                                                ₹{" "}
                                                {Number(
                                                    item.netSalary || 0
                                                ).toLocaleString(
                                                    "en-IN"
                                                )}
                                            </strong>
                                        </td>

                                        <td>
                                            <strong>
                                                ₹{" "}
                                                {Number(
                                                    item.balanceAmount || 0
                                                ).toLocaleString(
                                                    "en-IN"
                                                )}
                                            </strong>
                                        </td>

                                        <td>
                                            <button
                                                className="btn btn-sm btn-outline-dark"
                                                onClick={() =>
                                                    saveSalary(item)
                                                }
                                            >
                                                <i className="fa-solid fa-floppy-disk"></i>
                                            </button>
                                        </td>

                                    </tr>

                                ))

                            )}

                        </tbody>

                    </table>

                </div>

            </div>


            <style>{`

                .salary-page {
                    min-height: 100vh;
                    background: #f5f7fb;
                }

                .salary-header {
                    background: linear-gradient(
                        135deg,
                        #151c2c,
                        #293f62
                    );
                    color: white;
                    padding: 20px 24px;
                    border-radius: 18px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .header-title {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .header-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 14px;
                    background: rgba(255,255,255,.12);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 21px;
                }

                .salary-header h4 {
                    margin: 0;
                    font-weight: 700;
                }

                .salary-header small {
                    opacity: .7;
                }

                .month-selector {
                    display: flex;
                    gap: 8px;
                }

                .month-selector select {
                    min-width: 120px;
                    border: 0;
                }

                .summary-card {
                    background: white;
                    padding: 17px;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                }

                .summary-card small {
                    color: #8992a1;
                }

                .summary-card h4 {
                    margin: 5px 0 0;
                    font-weight: 800;
                }

                .summary-card.balance {
                    border-left: 4px solid #198754;
                }

                .salary-container {
                    background: white;
                    border-radius: 17px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                }

                .salary-toolbar {
                    padding: 17px 20px;
                    border-bottom: 1px solid #edf0f4;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .salary-toolbar h5 {
                    margin: 0;
                    font-weight: 700;
                }

                .salary-toolbar small {
                    color: #8b94a3;
                }

                .toolbar-actions {
                    display: flex;
                    gap: 8px;
                }

                .salary-table {
                    min-width: 1250px;
                }

                .salary-table thead th {
                    background: #f7f8fa;
                    border: 0;
                    padding: 13px 10px;
                    color: #687284;
                    font-size: 10px;
                    text-transform: uppercase;
                    white-space: nowrap;
                }

                .salary-table tbody td {
                    padding: 12px 10px;
                    border-color: #edf0f4;
                    vertical-align: middle;
                    font-size: 12px;
                }

                .employee-cell {
                    display: flex;
                    align-items: center;
                    gap: 9px;
                    min-width: 160px;
                }

                .employee-cell .avatar {
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    background: #edf2ff;
                    color: #4057c9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 800;
                }

                .employee-cell strong {
                    display: block;
                }

                .employee-cell small {
                    color: #9aa2af;
                }

                .days {
                    padding: 4px 8px;
                    border-radius: 15px;
                    font-weight: 700;
                }

                .days.present {
                    background: #eaf8ef;
                    color: #198754;
                }

                .days.absent {
                    background: #fdecec;
                    color: #dc3545;
                }

                .salary-input {
                    width: 75px;
                    border: 1px solid #e1e5ea;
                    border-radius: 7px;
                    padding: 5px 7px;
                    font-size: 12px;
                }

                .net-value {
                    color: #198754;
                }

            `}</style>

        </div>
    );
};

export default EmployeeSalary;

